import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from 'components/dropdown';
import StagePip from 'bundles/apex/deals/stages/pip';
import { getOrderedStages } from 'bundles/apex/helpers/stages';

function StageSelect({ setStage, stages, stage }) {
  const orderedStages = getOrderedStages(stages);

  return (
    <Dropdown
      icon={<StagePip stage={stage.key} />}
      label={stage.label}
    >
      {orderedStages.map(option => (
        <Dropdown.Item
          icon={<StagePip stage={option.key} />}
          key={option.key}
          label={option.label}
          onClick={() => setStage(option)}
        />
      ))}
    </Dropdown>
  );
}

StageSelect.propTypes = {
  className: PropTypes.string,
  setStage: PropTypes.func.isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  stages: PropTypes.object.isRequired,
};

export default StageSelect;
